import React, { FC } from 'react';
import { TextVariant } from '@naf/text';
import { Check } from '@styled-icons/material/Check';
import { Add } from '@styled-icons/material/Add';
import * as S from './MemberLabel.styles';

export interface MemberLabelProps {
  /**
   * Text for the label. E.g "NAF-Medlem", "MC-Medlem", or "Sykkel-Medlem".
   */
  labelText: string;

  /**
   * Changes the icon and it's background color based on eligibility.
   */
  isEligible?: boolean;

  /**
   * Should the text be inverted for dark backgrounds?
   */
  inverted?: boolean;

  /**
   * Optional className.
   */
  className?: string;
}

export const MemberLabel: FC<MemberLabelProps> = ({
  labelText = 'NAF-Medlem',
  isEligible = false,
  inverted = false,
  className,
}) => (
  <S.Container className={className}>
    <S.IconContainer $isEligible={isEligible}>{isEligible ? <Check size={16} /> : <Add size={16} />}</S.IconContainer>
    <S.TextContainer>
      <S.StyledText $inverted={inverted} variant={TextVariant.TagSmall}>
        {labelText}
      </S.StyledText>
    </S.TextContainer>
  </S.Container>
);

export default MemberLabel;
